module.exports = __webpack_public_path__ + "img/app.32b7bc3e.png";